import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { ApiService } from '../../../app/servicios/api/api.service';
import { Router } from '@angular/router';
import { LoginI } from 'src/app/modelos/login.interface';
import { ToastrService } from 'ngx-toastr';
declare var bootstrap: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnDestroy,OnInit {

  usuario:string = "";
  correo:string = "";
  nombre:string = "";
  tipoUsuario:string = "";
  expiracionToken : string;

  CambiarContrasena : string;
  ContrasenaActual : string;
  ContrasenaNueva : string;
  ContrasenaConfirma : string;
  BtnCambiar : Boolean;

  ProbLog : LoginI;

  @ViewChild('openModalContrasena') openModalContrasena: ElementRef;
  @ViewChild('closeModalContrasena') closeModalContrasena: ElementRef;

  PasswordNew = new FormControl('',[Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,16}$/)]);
  rol: string;

  FunPeriod : any;

  fechaFormateada: string;
  fechaComparar: Date;
  fechaActual: Date;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {

    this.usuario = localStorage.getItem('usuario');
    this.correo = localStorage.getItem('correo');
    this.nombre = localStorage.getItem('nombre');
    this.tipoUsuario = localStorage.getItem('tipo');
    this.rol = localStorage.getItem('rol');
    this.CambiarContrasena = localStorage.getItem('nuevaClave');
    this.expiracionToken = localStorage.getItem('ExpiracionToken');

    this.ProbLog = new LoginI;
    this.ContrasenaActual = "";
    this.ContrasenaNueva = "";
    this.ContrasenaConfirma = "";
    this.BtnCambiar = false;

    this.FunPeriod = setInterval(() => {
      this.ProbarToken();
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.FunPeriod) {
      clearInterval(this.FunPeriod);
    }
  }

  ProbarToken() {
    this.fechaActual = new Date();
    this.fechaComparar = new Date(this.expiracionToken);
    if(this.fechaActual>=this.fechaComparar){
      localStorage.clear();
      this.router.navigate(['login']);
      //window.location.reload();
      this.toastr.warning('El token ha caducado.', 'Advertencia!');
    }
  }

  datosUsuario(){
    this.usuario = localStorage.getItem('usuario');
    this.correo = localStorage.getItem('correo');
    this.nombre = localStorage.getItem('nombre');
    this.tipoUsuario = localStorage.getItem('tipo');
    this.rol = localStorage.getItem('rol');
  }

  onLogout(){
    localStorage.clear();
    this.router.navigate(['login']);
  }

  verificarContrasena(){
    this.ProbLog.username = this.usuario;
    this.ProbLog.password = this.ContrasenaActual;
    this.ContrasenaNueva = this.PasswordNew.value;
    this.api.loginUser(this.ProbLog).subscribe(data=>{
      localStorage.setItem("token",data.token);
      this.cambiarContrasena();
    }, error=>{
      this.toastr.error('Contraseña actual errada.', 'Error!');
    })
  }

  cambiarContrasena(){
    if (this.PasswordNew.invalid){
      this.BtnCambiar = true;
    } else {
      this.BtnCambiar = false;
    }
    if(this.ContrasenaNueva == this.ContrasenaConfirma){
      this.BtnCambiar = true;
      this.api.getUsuarioByUsername(this.usuario).subscribe(Usuario=>{
        //console.log(Usuario);
        Usuario.password = this.ContrasenaConfirma;
        this.api.nuevaClave(Usuario).subscribe(data1=>{
          this.toastr.success('Se cambio la contraseña.', 'OK!');
          this.closeModalContrasena.nativeElement.click();
          this.ngOnInit();
        }, error=>{
          this.toastr.error('No se pudo cambiar la contraseña.', 'Error!');
          this.ngOnInit();
        });
      },error=>{
        console.log(error);
      });
    } else {
      this.BtnCambiar = false;
      this.toastr.error('No coincide la nueva contraseña.', 'Error!');
    }
  }

  async verificarPeriodo() {
    await new Promise(resolve => setTimeout(resolve, 3600000));
    console.log("Token vencido.");
    localStorage.clear();
    this.router.navigate(['login']);
  }

}
